const wildcardPath = (path: string) => `${path}/*`;

export { wildcardPath };
